module.exports = __webpack_public_path__ + "static/media/ruwang.9ce13ec4.jpg";